var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMuscle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 68,
    viewBox: "0 0 92 68",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h92v68h-92z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(-1475.172 -743.138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1509.665 793.371c-3.228 1.857-11.521 4.694-16.284 3.54-2.234-.542-11.586-3.015-15.229-5.126-4.595-2.662 8.379-29.273 10.273-31.691 1.424-1.817 5.664-4.956 7.788-4.956 1.085 0 3.082 2.21 3.893 3.128a1.414 1.414 0 0 1 .355.938v.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1497.065 786.254c1.582-5.476-.2-16.247 2.024-17.543 5.057-.157 2.485-.587 7.181-1.573",
    transform: "translate(-5.808 -3.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1532.933 783.138c-6.372 0-12.744 3.54-14.868 7.788",
    transform: "translate(-11.94 -8.176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1530.685 813.926a44.328 44.328 0 0 1 -10.62-7.788",
    transform: "translate(-12.524 -14.892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1512.057 790.589c-4.954-2.24-9.912-1.416-12.744.708-1.218.913-4.248 2.832-4.248 2.832",
    transform: "translate(-5.224 -9.962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1509.481 765.97a1.42 1.42 0 0 0 1.416-1.416 1.42 1.42 0 0 0 -1.416-1.416h-1.416",
    transform: "translate(-9.02 -2.336)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuscle);
export default __webpack_public_path__ + "static/media/muscle.e0e5ea4c86865340fd96aeaa7f5ec4ac.svg";
export { ForwardRef as ReactComponent };